export default "__VITE_ASSET__B2jX4ANf__"